import {
  IPageLink,
  IPaginatedData,
  TAdminUser,
} from "../../../../models/superadmin";
import UserSection from "./UserSection";

// Props definition for UserList component
interface IUserListProps {
  adminUserList: {
    super_admins: IPaginatedData<TAdminUser>; // Paginated data for Super Admin users
    super_admins_total: number; // Total Super Admin users
    general_admins: IPaginatedData<TAdminUser>; // Paginated data for General Admin users
    general_admins_total: number; // Total General Admin users
  };
  searchInput: string; // Search term entered by the user
  openDropdown: boolean; // State to control dropdown visibility
  setOpenDropdown: (open: boolean) => void; // Setter for dropdown visibility
  handleEdit: (id: number | null, type: string) => void; // Function to handle editing a user

  // Super Admin pagination
  superAdminpaginationLinks: IPageLink[]; // Pagination links for Super Admin
  superAdmintotalPages: number; // Total pages for Super Admin
  superAdmincurrentPage: number; // Current active page for Super Admin
  setSuperAdminCurrentPage: (value: number) => void; // Setter for current page
  setSuperAdminPerPageList: (value: number) => void; // Setter for per-page item count
  handleSuperAdminPageChange: (url: string | null) => void; // Handles page change from pagination

  // General Admin pagination
  generalAdminpaginationLinks: IPageLink[]; // Pagination links for General Admin
  generalAdmintotalPages: number; // Total pages for General Admin
  generalAdmincurrentPage: number; // Current active page for General Admin
  setGeneralAdminCurrentPage: (value: number) => void; // Setter for current page
  setGeneralAdminPerPageList: (value: number) => void; // Setter for per-page item count
  handleGeneralAdminPageChange: (url: string | null) => void; // Handles page change from pagination

  getAllUsers: () => Promise<void>;
}

// Main UserList component to render user sections for both Super Admin and General Admin
export default function UserList(props: IUserListProps) {
  const {
    adminUserList,
    searchInput,
    handleEdit,
    superAdmincurrentPage,
    superAdmintotalPages,
    superAdminpaginationLinks,
    setSuperAdminPerPageList,
    setSuperAdminCurrentPage,
    handleSuperAdminPageChange,
    setGeneralAdminPerPageList,
    setGeneralAdminCurrentPage,
    generalAdmincurrentPage,
    generalAdmintotalPages,
    generalAdminpaginationLinks,
    handleGeneralAdminPageChange,
    getAllUsers
  } = props;

  return (
    <>
      <UserSection
        title="Super Admin"
        type="superAdmin"
        data={adminUserList?.super_admins.data}
        total={adminUserList?.super_admins_total}
        searchInput={searchInput}
        currentPage={superAdmincurrentPage}
        totalPages={superAdmintotalPages}
        paginationLinks={superAdminpaginationLinks}
        onPageChange={handleSuperAdminPageChange}
        setPerPageList={setSuperAdminPerPageList}
        setCurrentPage={setSuperAdminCurrentPage}
        handleEdit={handleEdit}
        getAllUsers={getAllUsers}
      />
      <UserSection
        title="General Admin"
        type="generalAdmin"
        data={adminUserList?.general_admins.data}
        total={adminUserList?.general_admins_total}
        searchInput={searchInput}
        currentPage={generalAdmincurrentPage}
        totalPages={generalAdmintotalPages}
        paginationLinks={generalAdminpaginationLinks}
        onPageChange={handleGeneralAdminPageChange}
        setPerPageList={setGeneralAdminPerPageList}
        setCurrentPage={setGeneralAdminCurrentPage}
        handleEdit={handleEdit}
        getAllUsers={getAllUsers}
      />
    </>
  );
}
